<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Manage ACSA / IA" class="card-container"></Header>
      <div class="col-md-12">
        <div class="row">
          <export-group :name="'ACSA/IAs'" :excelUrl="`api/acsareports/excel`" :getData="getExportData"></export-group>

          <div class="col-md-3 offset-md-5">
            <label for="searchBox">Search:</label>
            <el-input
              id="searchBox"
              type="search"
              class="mb-2 search-input"
              clearable
              prefix-icon="el-icon-search"
              v-model="searchQuery"
              aria-controls="datatables"
              placeholder="Search all ACSAs..."
            ></el-input>
          </div>
        </div>

        <div style="margin-left: -25px !important;" class="col-md-12">
          <el-table :data="queriedData" role="table"
        aria-label="Admin ACSA Table">
            <el-table-column :min-width="150" align="left" label="Actions">
              <div slot-scope="props">
                <span class="hide-if-medium-screensize"></span>
                <router-link
                  :to="{
                    name: 'AdminEditACSA',
                    params: { id: props.row.countryId },
                  }"
                  class="btn-link btn-primary"
                  :aria-label="`View ACSA ${props.row.countryId}`"
                >
                  <i class="tim-icons icon-zoom-split"></i>
                  <span class="hide-if-small-screensize"> View</span>
                </router-link>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              sortable
              :prop="column.prop"
              :label="column.label"
            ></el-table-column>
          </el-table>

          <div class="row justify-content-end">
            <label for="ResultsPerPageDropdown" class="results-per-page"
              >Results Per Page:</label
            >
            <el-select
              id="ResultsPerPageDropdown"
              v-model="pagination.perPage"
              readonly="false"
              name="PageOptions"
              class="select-primary"
            >
              <el-option
                v-for="(item, index) in pagination.perPageOptions"
                :value="item"
                class="select-primary"
                :key="index"
              ></el-option>
            </el-select>

            <base-pagination
              :per-page="pagination.perPage"
              v-model="pagination.currentPage"
              :total="total"
            />
          </div>
        </div>
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option, Button } from "element-ui";
import { Modal, BasePagination, BaseSwitch, ExportGroup } from "@/components";
import Treeselect from "@riophae/vue-treeselect";
import Header from "@/components/App/Header.vue";
import Util from "@/util/util";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "AdminAcsasDashboard",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BasePagination,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
    Button,
    ExportGroup,
  },
  data() {
    return {
      map: { 
        "SupportingNation": "name",
        "ActiveAcsa": "activeAgreementName",
        "ImplementArrangements": "implementArrangementCount",
        "Documents": "documentCount",
        "UpdateDate": "updateDate",
      },
      tableColumns: [
        {
          prop: "name",
          label: "Supporting Nation",
          minWidth: 210,
          scope: "col"
        },
        {
          prop: "activeAgreementName",
          label: "Active ACSA",
          minWidth: 180,
          scope: "col"
        },
        {
          prop: "implementArrangementCount",
          label: <span class="override-arrangementLable">Implement Arrangement(s)</span>,
          minWidth: 250,
          scope: "col"
        },
        {
          prop: "documentCount",
          label: "# of Documents",
          minWidth: 200,
          scope: "col"
        },
      ],
      pagination: {},
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
    };
  },
  async created() {
    this.$loaderApp.addRequest();
    await this.getAgreementCountries();
    this.pagination = Util.getInitialPaginationInfo();
    this.$loaderApp.completeRequest();
  },
  updated() {
    let searchableFields = [
      "name",
      "activeAgreementName",
      "implementArrangementCount",
      "documentCount",
    ];
    this.fuseSearch = Util.setFuseSearch(this.allTableData(), searchableFields);
  },
  watch: {
    searchQuery(value) {
      this.searchedData = Util.fuseSearch(
        this.allTableData(),
        this.fuseSearch,
        value
      );
    },
  },
  computed: {
    ...mapGetters({
      agreementCountries: "countries/agreementCountries",
    }),
    queriedData() {
      return Util.searchedData(
        this.allTableData(),
        this.searchedData,
        this.from,
        this.to
      );
    },
    to() {
      return Util.toPaginationPage(this.pagination, this.total);
    },
    from() {
      return Util.fromPaginationPage(this.pagination);
    },
    total() {
      return Util.numberOfPaginationPages(
        this.searchedData,
        this.allTableData()
      );
    },
  },
  methods: {
    ...mapActions({
      getAgreementCountries: "countries/getAgreementCountries",
    }),
    allTableData() {
      return this.agreementCountries;
    },
    getExportData() {
      let data = this.searchedData.length > 0 ? this.searchedData : 
        this.allTableData();
        
        return Util.mapTheData(data, this.map)
    },
  },
};
</script>

<style scoped>
.override-arrangementLable {
  text-transform: none !important;
}
</style>
